import React from 'react';
import './styles.css';
import {
    cfdi, 
    firma, 
    instalacion, 
    sello
} from './CFDI/imagenesCFDI'

export default function DescripcionCFDIFondo(props){


    return(<>
     <div className='contenedorDescripcionCFDIB'>
        <div className='contenedorGeneralDescripcionCFDIB'>
        <div className='contenedorTituloDescripcionCFDIB'>
            <p>¿QUÉ MÓDULOS PODRÁS ENCONTRAR?</p>
        </div>
        <div className='caracteristicasDescripcionCFDIB'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDIB'>
                    <img src={firma}/>
                </div>
                <div className='contenedorDescripcionCFDIBImagen'>
                    <p>Firma <br/> electrónica</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDIB'>
                    <img src={sello}/>
                </div>
                <div className='contenedorDescripcionCFDIBImagen'>
                    <p>Certificado<br/> de Sello Digital</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDIB'>
                    <img src={instalacion}/>
                </div>
                <div className='contenedorDescripcionCFDIBImagen'>
                    <p>Instalación del<br/> sistema T&T CFDIB</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDIB'>
                    <img src={cfdi}/>
                </div>
                <div className='contenedorDescripcionCFDIBImagen'>
                    <p>Iniciar la <br/> emisión de CFDI</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}